import { getPlatform } from '@/platform'

/** Commit hash baked into the build (`vite` `__COMMIT_HASH__`). */
export function getEmbeddedWebBundleVersion(): string | null {
  return typeof __COMMIT_HASH__ !== 'undefined' && __COMMIT_HASH__ !== '' ? __COMMIT_HASH__ : null
}

/**
 * Web bundle id for `x-player-web-version` (WS/HTTP) and playback-heartbeat `webVersion`:
 * on web, embedded hash; on Tauri, OTA `ota_bundle/.version` when applied, else embedded.
 */
export function getWebBundleVersion(): string | null | Promise<string | null> {
  if (getPlatform() === 'web') {
    return getEmbeddedWebBundleVersion()
  }
  return import('@tauri-apps/api/core').then(async ({ invoke }) => {
    const fromOta = await invoke<string | null>('ota_web_get_current_version')
    if (fromOta != null && fromOta !== '') {
      return fromOta
    }
    return getEmbeddedWebBundleVersion()
  })
}
